export type TypeOfEvent =
  | 'liability'
  | 'liability_munichre_to_getsafe_transfer_de'
  | 'liability_neodigital_de'
  | 'liability_neodigital_to_getsafe_transfer_de'
  | 'liability_getsafe_nxt_ag_de'
  | 'liability_luko_to_getsafe_de'
  | 'contents'
  | 'contents_neodigital_de'
  | 'contents_getsafe_nxt_ag_de'
  | 'contents_glass_getsafe_nxt_ag_de'
  | 'contents_bikes_getsafe_nxt_ag_de'
  | 'contents_bikes_munichre_to_getsafe_transfer_de'
  | 'contents_glass_munichre_to_getsafe_transfer_de'
  | 'contents_glass_neodigital_de'
  | 'contents_bikes_neodigital_de'
  | 'contents_bikes'
  | 'contents_munichre_to_getsafe_transfer_de'
  | 'bike_theft_glise_de'
  | 'contents_glass'
  | 'dental_cleaning' // old contract
  | 'dental_others' // old contract
  | 'dental_quotation_munichre_to_getsafe_transfer_de'
  | 'dental_cleaning_munichre_to_getsafe_transfer_de'
  | 'dental_others_munichre_to_getsafe_transfer_de'
  | 'dental_cleaning_munichre_de'
  | 'dog_liability_de'
  | 'dog_liability_getsafe_nxt_ag_de'
  | 'dog_liability_luko_to_getsafe_de'
  | 'accident_de'
  | 'bike_theft_neodigital_de'
  | 'car_iptiq_de'
  | 'dental_ottonova_de'
  | 'cost_treatment_plan_dental_ottonova_de'
  | 'travel_health_de'
  | 'household_liability_getsafe_nxt_ag_at'
  | 'household_dog_liability_getsafe_nxt_ag_at'
  | 'household_contents_getsafe_nxt_ag_at'
  | 'household_glass_getsafe_nxt_ag_at'
  | 'household_bike_getsafe_nxt_ag_at'
  | 'dog_liability_getsafe_nxt_ag_at'
  | 'liability_getsafe_nxt_ag_at'
  | 'pet_health_getsafe_nxt_ag_de'
  | 'legal_de'
  | 'home_getsafe_fr'
  | 'dog_liability_neodigital_to_getsafe_transfer_de'
  | 'contents_neodigital_to_getsafe_transfer_de'
  | 'contents_glass_neodigital_to_getsafe_transfer_de'
  | 'contents_bikes_neodigital_to_getsafe_transfer_de'
  | 'liability_munichre_de'
  | 'bike_theft_luko_to_getsafe_de'
  | 'pet_health_luko_to_getsafe_de'
  | 'contents_luko_to_getsafe_de'
  | 'contents_bikes_luko_to_getsafe_de'
  | 'contents_glass_luko_to_getsafe_de'
  | 'dental_quotation_munichre_de'
  | 'travel_health_berlin_direkt_de'
  | 'dental_getsafe_de'

// [hygen-marker] type of event

export type AbstractProductKey =
  | 'ap_home_fr'
  | 'ap_legal_basic_de'
  | 'ap_pet_health_de'
  | 'ap_household_at'
  | 'ap_dog_liability_at'
  | 'ap_liability_at'
  | 'ap_accident_basic_de'
  | 'ap_bike_basic_de'
  | 'ap_car_basic_de'
  | 'ap_contents_basic_de'
  | 'ap_dental_de'
  | 'ap_dog_liability_basic_de'
  | 'ap_liability_basic_de'
  | 'ap_travel_health_basic_de'
  | 'ap_travel_de'

export const TYPE_OF_EVENT_TO_ABSTRACT_PRODUCT_KEY_MAP: Record<TypeOfEvent, AbstractProductKey> = {
  home_getsafe_fr: 'ap_home_fr',
  legal_de: 'ap_legal_basic_de',
  pet_health_getsafe_nxt_ag_de: 'ap_pet_health_de',
  pet_health_luko_to_getsafe_de: 'ap_pet_health_de',
  household_bike_getsafe_nxt_ag_at: 'ap_household_at',
  household_glass_getsafe_nxt_ag_at: 'ap_household_at',
  household_contents_getsafe_nxt_ag_at: 'ap_household_at',
  household_liability_getsafe_nxt_ag_at: 'ap_household_at',
  household_dog_liability_getsafe_nxt_ag_at: 'ap_household_at',
  dog_liability_getsafe_nxt_ag_at: 'ap_dog_liability_at',
  liability_getsafe_nxt_ag_at: 'ap_liability_at',
  accident_de: 'ap_accident_basic_de',
  bike_theft_glise_de: 'ap_bike_basic_de',
  bike_theft_neodigital_de: 'ap_bike_basic_de',
  bike_theft_luko_to_getsafe_de: 'ap_bike_basic_de',
  car_iptiq_de: 'ap_car_basic_de',
  contents: 'ap_contents_basic_de',
  contents_munichre_to_getsafe_transfer_de: 'ap_contents_basic_de',
  contents_neodigital_de: 'ap_contents_basic_de',
  contents_getsafe_nxt_ag_de: 'ap_contents_basic_de',
  contents_glass_getsafe_nxt_ag_de: 'ap_contents_basic_de',
  contents_bikes_getsafe_nxt_ag_de: 'ap_contents_basic_de',
  contents_bikes: 'ap_contents_basic_de',
  contents_bikes_munichre_to_getsafe_transfer_de: 'ap_contents_basic_de',
  contents_bikes_neodigital_de: 'ap_contents_basic_de',
  contents_glass: 'ap_contents_basic_de',
  contents_glass_munichre_to_getsafe_transfer_de: 'ap_contents_basic_de',
  contents_glass_neodigital_de: 'ap_contents_basic_de',
  contents_neodigital_to_getsafe_transfer_de: 'ap_contents_basic_de',
  contents_glass_neodigital_to_getsafe_transfer_de: 'ap_contents_basic_de',
  contents_bikes_neodigital_to_getsafe_transfer_de: 'ap_contents_basic_de',
  contents_luko_to_getsafe_de: 'ap_contents_basic_de',
  contents_bikes_luko_to_getsafe_de: 'ap_contents_basic_de',
  contents_glass_luko_to_getsafe_de: 'ap_contents_basic_de',
  dental_cleaning: 'ap_dental_de', // old contract
  dental_others: 'ap_dental_de', // old contract
  dental_ottonova_de: 'ap_dental_de', // old contract
  dental_getsafe_de: 'ap_dental_de',
  dental_quotation_munichre_to_getsafe_transfer_de: 'ap_dental_de',
  dental_cleaning_munichre_to_getsafe_transfer_de: 'ap_dental_de',
  dental_others_munichre_to_getsafe_transfer_de: 'ap_dental_de',
  cost_treatment_plan_dental_ottonova_de: 'ap_dental_de',
  dog_liability_de: 'ap_dog_liability_basic_de',
  dog_liability_getsafe_nxt_ag_de: 'ap_dog_liability_basic_de',
  dog_liability_neodigital_to_getsafe_transfer_de: 'ap_dog_liability_basic_de',
  dog_liability_luko_to_getsafe_de: 'ap_dog_liability_basic_de',
  liability: 'ap_liability_basic_de',
  liability_neodigital_de: 'ap_liability_basic_de',
  liability_neodigital_to_getsafe_transfer_de: 'ap_liability_basic_de',
  liability_getsafe_nxt_ag_de: 'ap_liability_basic_de',
  liability_munichre_to_getsafe_transfer_de: 'ap_liability_basic_de',
  liability_munichre_de: 'ap_liability_basic_de',
  liability_luko_to_getsafe_de: 'ap_liability_basic_de',
  travel_health_de: 'ap_travel_health_basic_de',
  dental_cleaning_munichre_de: 'ap_dental_de',
  dental_quotation_munichre_de: 'ap_dental_de',
  travel_health_berlin_direkt_de: 'ap_travel_de',
}
